'use client';

import { IoArrowBack } from 'react-icons/io5';

import { IconButton } from '../../../../icon-button';
import { ResourceBody } from '../../../../resource';
import { SubmitBar } from '../../../layout/SubmitBar';
import { TitleBar } from '../../../layout/TitleBar';
import type { MultipleChoiceQuestionType } from '../../../multiple-choice-question/MultipleChoiceQuestion.types';
import { AssessmentIndex } from '../assessment-index/AssessmentIndex';

type IndexStepProps = {
  questions: MultipleChoiceQuestionType[];
  secondsLeft?: number;
  isSubmitting: boolean;
  /** Manual sittings do not submit from here — they go on to transcribe the answers. */
  submitLabel?: string;
  onGoToQuestion: (index: number) => void;
  onSubmit: () => void;
  onBack: () => void;
};

/** Every question at a glance, and the way out of the sitting. */
function IndexStep({
  questions,
  secondsLeft,
  isSubmitting,
  submitLabel,
  onGoToQuestion,
  onSubmit,
  onBack,
}: IndexStepProps) {
  return (
    <>
      <TitleBar title="Índice de preguntas" secondsLeft={secondsLeft} />
      <ResourceBody spacious={true}>
        <AssessmentIndex
          questions={questions}
          onSelect={(_, index) => onGoToQuestion(index)}
        />
      </ResourceBody>
      <SubmitBar
        isSubmitting={isSubmitting}
        label={submitLabel}
        onSubmit={onSubmit}
      >
        <IconButton
          icon={<IoArrowBack />}
          aria-label="Volver a la pregunta"
          onClick={onBack}
        />
      </SubmitBar>
    </>
  );
}

export { IndexStep };
